<template>
    <b-col cols="12" md="12" class="mt-3 p-3 form-control">
        <label class="mb-4 "><strong>{{ title }} 2 ({{ $translate('dropdown_options') }})</strong></label>
        <b-row>
            <b-col cols="12" class="d-flex flex-nowrap append-group-button gap-2">
                <div class="append-buttons">
                    <b-input id="search_additional_field" v-model="filter" type="text" :placeholder="$translate('search_additional_field_2')"></b-input>
                </div>
                <slot></slot>
            </b-col>
            <b-col class="page-block bg-transparent ms-3"><strong>{{ $translate('page') }}: {{ currentPage }} {{
                $translate('of') }}
                    {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                    {{ rows }}</strong></b-col>

        </b-row>

        <div class="responsive-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th v-for="item in fields" :key="item.key">{{ item.label }}</th>
                    </tr>
                </thead>
                <draggable tag="tbody" @end="onDragEnd" :options="draggableOptions" class="draggable-table">
                    <tr v-for="(item) in displayedItems" :key="item.id" class="draggable-item">
                        <td aria-colindex="1">
                            <b-button :id="'view-additional-field-btn-'+item.id" @click="$emit('show-item', item.id)" v-if="hasPermissionView" class="mr-2 test-view-additional-field-btn"
                                variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </td>
                        <td aria-colindex="2">
                            {{ item.name }}
                        </td>
                        <td aria-colindex="3">
                            <div class="form-check my-1">
                                <label class="form-check-label">
                                    <input type="checkbox" v-model="item.is_default
                                        " name="checkbox-secondaryItemsClosingBalances" :disabled="true"
                                        :value="true" />
                                    <i class="input-helper"></i>
                                </label>
                            </div>
                        </td>
                    </tr>
                </draggable>
            </table>
        </div>
        <!-- <b-table
            :fields="fields"
            responsive
            :items="items"
            :per-page="itemsPerPage"
            :current-page="currentPage"
            :filter="filter"
        >
            <template #cell(id)="row">
                <b-button
                    @click="$emit('show-item', row.item.id)"
                    v-if="hasPermissionView"
                    class="mr-2"
                    variant="pink-button"
                >
                    <img src="@/assets/images/icon/edit.svg" />
                </b-button>
            </template>
        </b-table> -->
    </b-col>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import draggable from 'vuedraggable';

export default {
    name: 'additionalFields-ListItems',
    mixins: [popupMixins, permissionsMixins],
    components: { draggable },
    props: {
        //type, // not used

        /**
         * List of items to  be displayed in the table
         */
        items: Array,
        /**
         * The title of the table
         */
        title: String,
    },

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
            draggableOptions: {
                animation: 300
            },
        }
    },

    mounted() {
        console.log("additional-field-items", this.items);
    },

    methods: {
        updateFilter() {
            this.currentPage = 1;
        },
        async onDragEnd(event) {
            try {
                this.items.splice(event.newIndex, 0, this.items.splice(event.oldIndex, 1)[0]);
                this.items.forEach(function (items, index) {
                    items.order = index;
                });
                const additionalFieldItems = this.items
                await this.$store.dispatch('additionalField/updateAdditionalFieldItemOrder', { additionalFieldItems })
                this.doToast(
                    this.$translate('success'),
                    this.$translate(`additional_field_sequence`),
                    'success'
                )
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            }
        },
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = this.$translate('delete_type')
            const message = `${this.$translate('delete_note')} ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('interactionType/delete', id)
                        .then(() => {
                            this.doToast(
                                this.$translate('deleted'),
                                this.$translate('item_delete_alert'),
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_delete_item'),
                                'danger'
                            )
                        })
                }
            })
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
                {
                    key: 'is_default',
                    label: this.$translate('default'),
                    formatter: value => (value ? 'Yes' : 'No'),
                },
            ]
        },
        filteredItems() {
            if (this.filter) {
                const lowerFilter = this.filter.toLowerCase();
                return this.items.filter(item =>
                    item.name.toLowerCase().includes(lowerFilter) ||
                    item.description.toLowerCase().includes(lowerFilter)
                );
            } else {
                return this.items;
            }
        },
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.filteredItems && this.filteredItems.slice(startIndex, endIndex);
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items ? this.items.length : ''
        },
    },
}
</script>
<style></style>
